module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_arrow5-01d50df9bbdf895dc31898e4a2f2c0e4.svg";